import React from 'react';
import { ShieldCheck, Download, Lock } from 'lucide-react';
export function TrustBadges() {
  return <div className="mt-12 text-center" data-id="element-171">
      <div className="flex flex-col items-center justify-center gap-3 mb-6" data-id="element-172">
        <p className="text-sm text-gray-500" data-id="element-173">Pago 100% seguro procesado por:</p>
        <img src="https://cdn.magicpatterns.com/uploads/fwyNuTLm3hcaXpJCfr6akg/ML.jpg" alt="Mercado Libre - Mercado Pago" className="h-10 object-contain" data-id="element-174" />
      </div>

      <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm text-gray-600" data-id="element-175">
        <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm border border-gray-100" data-id="element-176">
          <Download size={16} className="text-[#9CAF88]" data-id="element-177" />
          <span data-id="element-178">Descarga inmediata</span>
        </div>
        <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm border border-gray-100" data-id="element-179">
          <ShieldCheck size={16} className="text-[#9CAF88]" data-id="element-180" />
          <span data-id="element-181">Garantía de satisfacción</span>
        </div>
        <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm border border-gray-100" data-id="element-182">
          <Lock size={16} className="text-[#9CAF88]" data-id="element-183" />
          <span data-id="element-184">Datos protegidos</span>
        </div>
      </div>
    </div>;
}